import {Injectable, inject} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {FirestoreService} from "./firestore.service";
import {ClientInContextService} from "./client-in-context.service";
import {AuthService} from "./auth.service";

/**
 * Service that monitors route transitions and intercept navigation events to synchronize
 * URL parameters and active context across services.
 */
@Injectable({
  providedIn: 'root'
})
export class UrlNavigationInterceptorService {
  private router = inject(Router);
  private firestoreService = inject(FirestoreService);
  private clientInContextService = inject(ClientInContextService);
  private authService = inject(AuthService);

  private loggedInUserDocData: any;
  private navigationEvent?: NavigationEnd;

  constructor() {
    this.router.events.subscribe((event) => {

    });
  }
}

